export const defaultPlayerCount = 2
